/**
 * Textos (`ca`) de les vistes d'Existències per LLOCS i per ARTICLE i del moviment múltiple (OBR-145). Namespace `backoffice.stockViews`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (`views.test.ts` i i18n.test.ts); cap text literal a
 * les vistes. Plurals amb `_one` / `_other` i `count`.
 */

export const viewsCa = {
  'backoffice.stockViews': {
    // Commutador de vista
    modeLabel: 'Vista d’existències',
    modePlaces: 'Per llocs',
    modeArticles: 'Per article',

    // L'arbre de llocs
    treeLabel: 'Llocs de l’obrador',
    treeHint: 'Tria un lloc per veure què hi ha. Només es llegeix el lloc triat.',
    treeExpand: 'Desplega {{place}}',
    treeCollapse: 'Plega {{place}}',
    treeNoStock: 'Sense existències',
    treeInactive: 'De baixa',
    treeNoPlaceHint: 'El que es va rebre abans que existís l’estructura de l’obrador.',
    treeEmptyStructure:
      'L’obrador encara no té cap zona definida. Pots veure el que no té lloc a «Sense lloc» i definir l’estructura a Configuració.',
    structureLoadError:
      'No s’ha pogut llegir l’estructura de l’obrador (zones, seccions i ubicacions): no es pot dir que no n’hi hagi. Torna-ho a provar.',
    leadDaysUnknown:
      'No s’han pogut llegir els dies d’avís de caducitat de l’obrador: no es pot dir quins lots caduquen aviat, i els que encara no han caducat es veuen sense color.',

    // El lloc triat
    placeLinesCount_one: '{{count}} lot',
    placeLinesCount_other: '{{count}} lots',
    placeMore: 'Hi ha més lots en aquest lloc: carrega’n més.',
    placeEmpty: 'No hi ha existències en aquest lloc.',
    placeEmptyNone: 'Tot té lloc: no hi ha existències sense lloc.',
    placeLoadError: 'No s’han pogut carregar les existències d’aquest lloc. Torna-ho a provar.',
    placeLoadMoreError: 'No s’han pogut carregar més lots. Torna-ho a provar.',
    placeRetry: 'Torna-ho a provar',
    loadMore: 'Carrega’n més',
    loadingMore: 'Carregant…',
    groupLabel: 'Lloc: {{place}}',

    // Una card (un lot en un lloc)
    cardNoLot: 'Sense lot',
    cardSupplierLot: 'Lot del proveïdor: {{code}}',
    cardExpiry: 'Caducitat',
    cardPlace: 'Lloc',
    selectLine: 'Selecciona el lot {{lot}} per moure’l',
    selectNoStock: 'No hi ha existències en aquest lloc: no hi ha res a moure.',
    selectUntracked: 'Aquest article no té control d’existències: no hi ha res a moure.',
    selectArticleGone: 'Aquest article està donat de baixa: no es pot moure.',

    // Caducitat
    expiryNone: 'Sense caducitat',
    expiryToday: 'Caduca avui',
    expiryTomorrow: 'Caduca demà',
    expiryIn: 'Caduca d’aquí {{count}} dies',
    expiryYesterday: 'Va caducar ahir',
    expiryAgo: 'Va caducar fa {{count}} dies',

    // Línia de temps de caducitats (per article)
    timelineTitle: 'Caducitats',
    timelineAria: 'Línia de temps de les caducitats dels lots amb existències',
    timelineToday: 'Avui',
    timelineSoon: 'Caduca aviat',
    timelineDayUnit: 'd',
    timelineLegendExpired: 'Caducat',
    timelineLegendSoon: 'Caduca aviat',
    timelineLegendOk: 'Amb temps',
    timelineUndated: 'Sense caducitat: {{lots}}',
    timelineEmpty: 'Cap lot amb existències i caducitat per dibuixar.',
    timelineBar: '{{lot}}: {{when}}',

    // La barra de selecció
    selectionCount_one: '{{count}} lot seleccionat',
    selectionCount_other: '{{count}} lots seleccionats',
    selectionMove: 'Mou la selecció',
    selectionClear: 'Esborra la selecció',
    selectionDropped:
      'S’han tret de la selecció {{count}} lots que ja no es poden moure (han canviat o ja no tenen existències).',
    moveDone_one: 'S’ha mogut {{count}} lot a {{place}}.',
    moveDone_other: 'S’han mogut {{count}} lots a {{place}}.',
    moveDoneDismiss: 'Tanca l’avís',

    // El diàleg del moviment múltiple
    batchTitle: 'Mou la selecció',
    batchBody:
      'Tots els lots van al mateix lloc. La quantitat de cada lot comença per tot el que hi ha a l’origen; la pots baixar per moure’n només una part. Si un lot falla, no es mou cap.',
    batchDestination: 'Lloc de destí',
    batchDestinationPlaceholder: 'Tria on van',
    batchNote: 'Nota',
    batchNotePlaceholder: 'Opcional: per què es mouen',
    batchColLot: 'Lot',
    batchColFrom: 'Origen',
    batchColQuantity: 'Quantitat a moure',
    batchColRemaining: 'Quedarà a l’origen',
    batchAvailable: 'Hi ha {{quantity}} {{unit}}',
    batchAtDestination: 'Ja és al destí: no es mourà.',
    batchQuantityInvalid: 'Escriu una quantitat més gran que zero.',
    batchQuantityExceeds: 'No pot passar de les {{quantity}} {{unit}} que hi ha a l’origen.',
    batchNotSelectable: 'Aquest lot ja no es pot moure.',
    batchSummary_one: 'Es mourà {{count}} lot a {{place}}.',
    batchSummary_other: 'Es mouran {{count}} lots a {{place}}.',
    batchSkipped_one: '{{count}} lot ja és al destí i no es mourà.',
    batchSkipped_other: '{{count}} lots ja són al destí i no es mouran.',
    batchTooMany: 'Un moviment admet com a màxim {{max}} lots. Treu-ne de la selecció.',
    batchWarning:
      'Hi ha lots bloquejats o caducats a la selecció. Es poden moure, però no es poden consumir ni expedir. Els bloquejats a mà arriben bloquejats al destí: la quarantena segueix la mercaderia.',
    batchNoDestinations: 'No hi ha cap lloc de destí que admeti existències. Defineix-ne un a Configuració.',
    batchConfirm: 'Mou',
    batchFailed: 'No s’ha mogut res. {{reason}}',
    batchFailedItem: 'No s’ha mogut res. El lot {{lot}} ({{article}}): {{reason}}',
    batchFailedHint: 'Pots corregir-ho i tornar a prémer «Mou».',

    // Errors del servidor, en llenguatge d'obrador
    err_move_stock_batch_empty: 'No hi ha cap lot per moure.',
    err_move_stock_batch_too_large: 'Hi ha massa lots en un sol moviment (màxim 200).',
    err_move_stock_batch_client_uuid_conflict:
      'Aquesta operació ja correspon a un altre moviment. Torna a obrir el diàleg i prova-ho de nou.',
    err_move_stock_forbidden: 'No tens permís per moure existències.',
    err_move_stock_no_tenant: 'No s’ha pogut identificar l’obrador. Torna a entrar.',
    err_move_stock_batch_bad_item: 'Les dades d’aquest lot no són vàlides.',
    err_move_stock_batch_duplicate: 'Aquest lot surt dues vegades del mateix lloc.',
    err_move_stock_batch_chained: 'El destí d’un lot és l’origen d’un altre del mateix lot.',
    err_move_stock_insufficient:
      'A l’origen ja no hi ha prou existències: han canviat des que vas triar el lot. Torna-ho a mirar.',
    err_move_stock_same_place: 'Aquest lot ja és al lloc de destí.',
    err_move_stock_no_destination: 'Tria un lloc de destí.',
    err_move_stock_bad_destination: 'El lloc de destí ja no existeix o no és d’aquest obrador.',
    err_move_stock_destination_without_stock: 'El lloc de destí no admet existències.',
    err_move_stock_two_lots: 'Un moviment pertany a un sol lot.',
    err_move_stock_unknown_article: 'Aquest article ja no existeix en aquest obrador.',
    err_move_stock_unknown_lot: 'Aquest lot ja no existeix o no és d’aquest article.',
    err_move_stock_bad_quantity: 'La quantitat no és vàlida.',
    err_unknown: 'No s’ha pogut fer el moviment.',
  },
} as const;
